import * as React from 'react';

import { BankOperationsListComment } from 'pages/Finance/BankOperations/BankOperationsList/BankOperationsListComment/BankOperationsListComment';
import { BankOperationCommentsSkeleton } from 'pages/Finance/BankOperations/components/BankOperationCommentsSkeleton';
import { useBankOperationComments } from 'pages/Finance/BankOperations/hooks/useBankOperationComments';
import { RecordContextProvider } from 'react-admin';
import { Card, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { BankOperation } from 'types/embedded/bankOperation';

type Props = DialogProps & {
  record: BankOperation | undefined;
};

export const BankOperationsListCommentDialog: React.FC<Props> = ({ record, ...restProps }) => {
  const { comments, isLoading } = useBankOperationComments(record?.originId, restProps.open);

  return (
    <Dialog {...restProps} width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={restProps.onClose} />]}
          sx={{ height: 'auto' }}
          title="Комментарий при изменении статуса"
          titleSize="smallBold"
        />
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            padding: '24px !important',
          }}
        >
          {isLoading ? (
            <BankOperationCommentsSkeleton />
          ) : (
            comments.map((comment) => (
              <RecordContextProvider key={comment.id} value={comment}>
                <BankOperationsListComment />
              </RecordContextProvider>
            ))
          )}
        </CardContent>
      </Card>
    </Dialog>
  );
};
